import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import type { HasRoleOptions } from '../../../routes/login/store/AuthSession';
import { getMenuRoutes } from '../../../routes/routes';
import { Role } from '../../../routes/users/store/User';
import { useAccount, useStore } from '../../../store';
import { Icon } from '../../display';
import { IconName } from '../../display/Icon';
import classes from './MainMenu.module.scss';

export default function MainMenu() {
  const account = useAccount({ throwIfEmpty: false });
  const { authStore } = useStore();

  const routes = getMenuRoutes({
    account,
    userHasRole(role: Role, options?: HasRoleOptions) {
      return authStore.userHasRole(role, options);
    },
  });

  return (
    <ul className={clsx(classes.root, classes.mainMenu)}>
      {routes.map((route) => (
        <MenuItem
          icon={route.icon}
          key={route.route}
          route={route.route}
          title={route.title}
        />
      ))}
    </ul>
  );
}

function MenuItem({
  title,
  route,
  icon,
}: {
  icon: IconName;
  route: string;
  title: string;
}) {
  return (
    <li className={classes.item}>
      <NavLink
        className={({ isActive }) =>
          clsx(classes.link, isActive && classes.active)
        }
        to={route}
      >
        <Icon className={classes.icon} icon={icon} size="medium" />
        {title}
      </NavLink>
    </li>
  );
}
